import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * コンサルタント：閲覧承認前に表示するボタンコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalOneViewRequestText = (props) => {
    const { className = '', isAutoApproval, isNotViewRequested, isViewRequestRejected, } = props;
    // 指定位置で確実に折り返されるようにしておく
    const textClassName = clsx('inline-flex', 'whitespace-nowrap');
    const text = (() => {
        //  閲覧申請自動承認、かつ閲覧申請が作成されていない場合
        if (isAutoApproval && isNotViewRequested) {
            return (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: textClassName }, { children: "\u8A73\u7D30\u95B2\u89A7\u7533\u8ACB\u306F\u4E0D\u8981\u3067\u3059\u3002" })), _jsx("span", Object.assign({ className: textClassName }, { children: "\u4E0A\u8A18\u30DC\u30BF\u30F3\u3092\u62BC\u4E0B\u5F8C\u3001\u3059\u3050\u306B\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059" }))] }));
        }
        // 閲覧申請自動承認でない場合
        return !isAutoApproval && !isViewRequestRejected ? (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: textClassName }, { children: "\u627F\u8A8D\u5F8C\u306B\u4F01\u696D\u540D\u306A\u3069\u306E" })), _jsx("span", Object.assign({ className: textClassName }, { children: "\u8A73\u7D30\u60C5\u5831\u304C\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059" }))] })) : null;
    })();
    if (!text) {
        return null;
    }
    return (_jsx(Text, Object.assign({ className: clsx(className), color: 'base', size: 'sm' }, { children: text })));
};
